import React from 'react';

import CustomModal from '../Elements/CustomModal';

// El vídeo vive en public/assets/video (CRA lo copia tal cual al build), no en un
// artifact de Claude ni en un mp4 suelto por WhatsApp: el club no tiene cuenta de
// Claude, y el que entra al equipo tres meses después nunca vio ese WhatsApp.
// Servido desde la propia app, está donde se usa y viaja en el mismo deploy.
const VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/assets/video/smack-demo.mp4`;
const POSTER_SRC = `${process.env.PUBLIC_URL || ''}/assets/video/smack-demo-poster.jpg`;

/**
 * Vídeo de onboarding de Smack (51 s, con voz). `preload="metadata"` a propósito:
 * son 1,8 MB y quien no le da al play no se los descarga.
 */
export default function HelpVideoModal({ active, onClose }) {
  return (
    <CustomModal
      active={active}
      handleModal={onClose}
      title="¿Cómo funciona Smack?"
      size="large"
      titleId="smack-help-video-title"
    >
      <div className="space-y-3">
        <video
          className="w-full rounded-lg bg-black"
          src={VIDEO_SRC}
          poster={POSTER_SRC}
          controls
          playsInline
          preload="metadata"
        >
          Tu navegador no puede reproducir el vídeo.
        </video>
        <p className="text-sm text-gray-600">
          51 segundos: cómo avisar al equipo desde la pantalla donde estás, con la
          captura y el contexto ya puestos, y cómo queda apuntado hasta que se resuelve.
        </p>
      </div>
    </CustomModal>
  );
}
